<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <!-- formulario -->
    <v-row>
      <v-col
        sm="1"
        lg="2"
        class="hidden-xs-only"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              small
              fixed
              exact
              color="primary"
              v-bind="attrs" 
              v-on="on" 
              @click="regresar"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
          </template>
          <span>Regresar</span>
        </v-tooltip>
      </v-col>
      <v-col 
        cols="12" 
        sm="10" 
        lg="8"
      >
        <v-card 
          outlined 
          elevation="2" 
          :loading="loadingForm"
        >
          <v-card-title class="justify-center">
            <p class="text-h4 font-weight-bold primary--text mt-2">
              Actualizar Categoria
            </p>
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <v-col 
                cols="12" 
                sm="10" 
                lg="8"
              >
                <v-form 
                  ref="form" 
                  v-model="form"
                >
                  <v-select
                    outlined
                    multiple
                    small-chips
                    label="Programa de Formación*"
                    :items="programasFormacion"
                    item-value="id"
                    item-text="programa_formacion"
                    v-model="programaFormacion"
                    :rules="programaFormacionReglas"
                  >
                  </v-select>

                  <v-text-field
                    outlined
                    dense
                    type="text"
                    label="Categoria*"
                    maxlength="100"
                    counter
                    v-model.trim="categoria"
                    :rules="categoriaReglas"
                  >
                  </v-text-field>

                  <v-file-input
                    outlined
                    dense
                    prepend-icon=""
                    append-icon="mdi-paperclip"
                    accept="image/png, image/jpeg"
                    label="Logotipo"
                    truncate-length="50"
                    counter
                    show-size
                    v-model="logotipo"
                    :rules="logotipoReglas"
                  >
                  </v-file-input>

                  <v-textarea
                    outlined
                    rows="4"
                    label="Descripción"
                    v-model.trim="descripcion"
                  >
                  </v-textarea>

                  <v-file-input
                    outlined
                    dense
                    prepend-icon=""
                    append-icon="mdi-paperclip"
                    accept="application/pdf"
                    label="Lineamientos"
                    truncate-length="100"
                    counter
                    show-size
                    v-model="documentoLineamientos"
                    :rules="documentoLineamientosReglas"
                  >
                  </v-file-input>

                  <v-select
                    outlined
                    multiple
                    small-chips
                    label="Aliado"
                    :items="aliados"
                    item-value="id"
                    item-text="aliado"
                    v-model="aliado"
                  >
                  </v-select>

                  <v-btn
                    large
                    block
                    exact
                    elevation="2"
                    color="primary"
                    class="mt-2 mb-6"
                    @click="actualizar"
                  >
                    Actualizar
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Alert from '../../../components/admin/Alert.vue'

export default {
  data: () => ({
    alert: false,
    alertType: '',
    alertTitle: '',
    alertMessage: '',

    form: true,
    loadingForm: false,

    programaFormacion: [],
    programaFormacionReglas: [
      v => (v && v.length > 0) || "Seleccione minimo un programa de formación"
    ],
    
    categoria: '',
    categoriaReglas: [
      v => !!v || "Escriba una categoria"
    ],

    logotipo: null,
    logotipoReglas: [
      v => !v || v.size < 2000000 || "El tamaño del logotipo debe ser menor que 2 MB"
    ],
    
    descripcion: '',

    documentoLineamientos: null,
    documentoLineamientosReglas: [
      v => !v || v.size < 5000000 || "El tamaño del documento debe ser menor que 5 MB"
    ],

    aliado: [],
    aliadoReglas:[
      v => (v && v.length > 0) || "Seleccione minimo un aliado"
    ]
  }),

  components: {
    Alert
  },

  mounted() {
    this.$store.dispatch("crearProgramasFormacion")
    this.$store.dispatch("gestionarAliados")
    this.$store.dispatch("editarCategoria", this.$route.params.id_categoria)
    .then((response) => {
      response.programasFormacion.forEach((programaFormacion) => {
        this.programaFormacion.push(programaFormacion.programa_formacion_id)
      });

      response.aliados.forEach((aliado) => {
        this.aliado.push(aliado.aliado_id)
      });

      this.categoria = response.categoria.categoria
      this.descripcion = response.categoria.descripcion
    })
    .catch(() => {});    
  },

  computed: {
    programasFormacion() {
      return this.$store.getters.obtenerProgramasFormacion
    },

    aliados() {
      return this.$store.getters.obtenerAliados
    }
  },

  methods: {
    actualizar() {
      if (this.$refs.form.validate()) {
        const categoria = new FormData();
        categoria.set('_method', 'PUT');
        categoria.set("id",                     this.$route.params.id_categoria)
        categoria.set("programa_formacion_id",  this.programaFormacion)
        categoria.set("categoria",              this.categoria.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()))
        categoria.set("logotipo",               this.logotipo)
        categoria.set("descripcion",            this.descripcion)
        categoria.set("doc_lineamiento_categoria", 7);
        categoria.set("documento_lineamientos", this.documentoLineamientos)
        categoria.set("aliado_id",              this.aliado)

        this.loadingForm = true;

        this.$store.dispatch("actualizarCategoria", categoria)
        .then((response) => {
          if (response.status == "success") {
            this.loadingForm  = false;

            let message       = response.message.split(',')
            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;

            setTimeout(() => {
              this.alert = false;
              this.$router.replace({ name: "categoria-gestionar" });
            }, 2000);
          } 
          else {
            this.loadingForm  = false;
            this.alertType    = "error--text";
            this.alertTitle   = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }

            this.alert        = true;

            setTimeout(() => {
              this.alert = false;
            }, 3000);
          }
        })
        .catch(() => {});
      }
    },

    regresar() {
      this.$router.back()
    }
  },
};
</script>